import React, { useEffect } from "react";
import { ListGroup } from "react-bootstrap";
import { connect } from "react-redux";

import { Skeleton, TablePagination, EmptyBlock } from "components";
import { pendActions } from "store";
import { PendType, GetPendList, SetPaging, NameId } from "types";

import PendDetailsRow from "./pendDetailsRow";

import styles from "../pend.module.scss";

type PendDetailsProps = {
	loading: boolean;
	id: string;
	nameId: NameId;
	list: PendType[];
	count: number;
	page: number;
	getPendList: GetPendList;
	setPagingPendDetails: SetPaging;
	urlPendPage: string;
};

const PAGE_SIZE = 50;

const PendDetails = ({
	loading,
	id,
	nameId,
	list,
	count,
	page,
	getPendList,
	setPagingPendDetails,
	urlPendPage,
}: PendDetailsProps) => {
	useEffect(() => {
		getPendList(nameId, id, PAGE_SIZE);
	}, [getPendList, nameId, id]);

	const Loader = ({ skeleton, component }) => {
		return loading ? skeleton() : component();
	};

	const handlePageChange = page => {
		//Server starts counting from 0
		setPagingPendDetails(page - 1);
		getPendList(nameId, id, PAGE_SIZE);
	};

	return (
		<Loader
			skeleton={() => (
				<div className={styles.fullPage}>
					<Skeleton />
				</div>
			)}
			component={() =>
				list.length > 0 ? (
					<>
						<div className={styles.wrraperContent}>
							<ListGroup>
								{list.map((pend, index) => (
									<PendDetailsRow
										key={index}
										pend={pend}
										urlPendPage={urlPendPage}
									/>
								))}
							</ListGroup>
						</div>
						<div className={styles.pagingWrapper}>
							<TablePagination
								page={page}
								itemsCountPerPage={PAGE_SIZE}
								count={count}
								handlePageChange={handlePageChange}
							/>
						</div>
					</>
				) : (
					<div className={styles.fullPage}>
						<EmptyBlock />
					</div>
				)
			}
		/>
	);
};

const mapStateToProps = state => ({
	loading: state.pend.pendDetails.loading,
	list: state.pend.pendDetails.list,
	count: state.pend.pendDetails.count,
	page: state.pend.pendDetails.page,
});

const mapDispatchToProps = {
	getPendList: pendActions.getPendList,
	setPagingPendDetails: pendActions.setPagingPendDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(PendDetails);
